import {Component, ElementRef, NgZone, ViewChild} from '@angular/core';
import {MapsAPILoader} from '@agm/core';
import {DataService} from '../core/data.service';
import {KennelSummary} from '../core/KennelSummary';
import {Observable} from 'rxjs';
import {Kennel} from '../core/Kennel';
import {RestStateInterface} from '../core/RestStateInterface';
import {Page} from '../core/Page';
import {CustomAuthService} from '../auth.service';
import {Router} from '@angular/router';
import {AlertService} from '../alert.service';
import { AnimationType } from '../shared/carousel/carousel.animations';
import {CarouselComponent} from '../shared/carousel/carousel.component';

@Component({
  templateUrl: 'home.component.html',
  styleUrls: ['home.component.scss']
})
export class HomeComponent {

  loggedIn = false;
  isAdmin = false;
  name = 'Welcome Back!';
  userPic = 'https://icon-library.net/images/default-user-icon/default-user-icon-4.jpg';

  asCustomer = false;
  asKennel   = false;
  dateIn: any;
  dateOut: any;
  showValidationErrors = false;
  showLocationError = false;
  fromDateError = '';
  toDateError = '';
  numCats: number;
  numDogs: number;
  numCatPens: number = null;
  numDogPens: number = null;
  maxDistance = 10;



  title = 'AGM';
  latitude: number;
  longitude: number;
  address = '';
  private geoCoder;
  kennelResults: KennelSummary[];
  kennelResults$: Observable<Page<KennelSummary>>;
  selectedKennel: KennelSummary;




    animationType = AnimationType.Fade;
    @ViewChild(CarouselComponent, {static: false}) carousel: CarouselComponent;




  // TODO this is being called too often, check if changed?
  @ViewChild('search', { static: false }) set searchElementRef(searchElementRef: ElementRef) {
    if (searchElementRef) {
      this.loadMap(searchElementRef.nativeElement);
    }
  }
  @ViewChild('resultsTable', { static: false }) ResultsTable: ElementRef;

  constructor(private mapsAPILoader: MapsAPILoader,
              private ngZone: NgZone,
              private router: Router,
              public authService: CustomAuthService,
              private alertService: AlertService,
              private dataService: DataService) {
      authService.loggedInStream$.subscribe(
          val => {
              console.log(val);
              this.loggedIn = val;
          });
      authService.isAdminStream$.subscribe(
          val => {
              this.isAdmin = val;
          });
      authService.userNameStream$.subscribe(
          val => {
              this.name = val;
          });
      authService.userPicStream$.subscribe(
          val => {
              if (val) {
                  this.userPic = val;
              }
          });
      // to check session and if exists then login
      const loggedIn = localStorage.getItem('loggedIn');
      if (loggedIn) {
          this.authService.sendToRestApiMethodDevMode(loggedIn);
      } else {
          this.authService.logout();
      }
  }


  loadMap(nativeElement: any) {
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder();

      const autocomplete = new google.maps.places.Autocomplete(
          nativeElement,
          {
            types: ['address']
          }
      );
      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();

          // verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          // set latitude, longitude
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.getAddress(this.latitude, this.longitude);
        });
      });
    });
  }








  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(position => {
        // this.latitude = position.coords.latitude;
        // this.longitude = position.coords.longitude;
        // this.getAddress(this.latitude, this.longitude);
      });
    }
  }

  getAddress(latitude, longitude) {
    if (!latitude || !longitude) {
        this.showLocationError = true;
    } else {
          this.showLocationError = false;
    }
    this.geoCoder.geocode(
        { location: { lat: latitude, lng: longitude } },
        (results, status) => {
          console.log(results);
          console.log(status);
          if (status === 'OK') {
            if (results[0]) {
                this.address = results[0].formatted_address;
            } else {
              window.alert('No results found');
            }
          } else {
            window.alert('Geocoder failed due to: ' + status);
          }
        }
    );
  }

  onDateChange(toFrom) {
      if (toFrom === 1) {
          const current = new Date().getTime();
          const selectedDate = new Date(this.dateIn).getTime();
          if (selectedDate < current) {
              this.fromDateError = 'Please select From date in future';
              this.showValidationErrors = true;
          } else {
              this.fromDateError = '';
          }
      } else if (toFrom === 2) {
          const fromDate = new Date(this.dateIn).getTime();
          const toDate = new Date(this.dateOut).getTime();
          if (toDate < fromDate) {
              this.toDateError = 'Please select To date greater than From date';
              this.showValidationErrors = true;
          } else {
              this.toDateError = '';
          }
      } else {
          const current = new Date().getTime();
          const fromDate = new Date(this.dateIn).getTime();
          const toDate = new Date(this.dateOut).getTime();
          if ((fromDate < current) || (toDate < fromDate)) {
              this.showValidationErrors = true;
          }
      }
  }

  findKennels() {
    const state: RestStateInterface = {};
    this.showValidationErrors = false;
    state.filters = [];
    state.filters.push({'property': 'latatitude', 'value': this.latitude});
    state.filters.push({'property': 'longatude', 'value': this.longitude});
    state.filters.push({'property': 'maxDistance', 'value': this.maxDistance});
    if (!this.latitude || !this.longitude || !this.maxDistance) {
        this.showLocationError = true;
    } else {
        this.showLocationError = false;
    }
    if (this.numCatPens && this.numCatPens > 0) {
      state.filters.push({'property': 'catPens', 'value': this.numCatPens});
    }
    if (this.numDogPens && this.numDogPens > 0) {
      state.filters.push({'property': 'dogPens', 'value': this.numDogPens});
    }
    if ((!this.numCatPens || this.numCatPens === 0) && (!this.numDogPens || this.numDogPens === 0)) {
        this.showValidationErrors = true;
    }
    if (!this.dateIn || !this.dateOut) {
        if (!this.dateIn) {
            this.fromDateError = 'Please select From date';
        }
        if (!this.dateOut) {
            this.toDateError = 'Please select To date';
        }
        this.showValidationErrors = true;
    } else {
        this.onDateChange(3);
    }
    if (this.showValidationErrors) {
        return;
    }
    state.filters.push({'property': 'dateIn', 'value': this.dateIn});
    state.filters.push({'property': 'dateOut', 'value': this.dateOut});
    this.kennelResults$ = this.dataService.callGetPaged('kennel/availability', state);
    this.kennelResults$.subscribe(
        x => {
            this.kennelResults = x.content;
          this.ResultsTable.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (this.kennelResults.length === 0) {
            console.log('No kennels found'); // TODO message on screen
          }
        },
        error => {
          console.log(error);
        }
    );
  }

  selectKennel($event) {
    this.selectedKennel = $event;
    // todo remove dirty hack
    this.selectedKennel.images = ['https://www.southern-timber.co.uk/wp-content/uploads/2019/02/rowlinsons_dog_kennel_large.jpg',
        'https://images-na.ssl-images-amazon.com/images/I/813nW9YacfL._AC_SL1500_.jpg',
        'https://cdn.shopify.com/s/files/1/2327/5701/articles/Omega-3-For-Dogs_1200x.jpg?v=1561351694',
        // tslint:disable-next-line:max-line-length
        'https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/article_thumbnails/slideshows/surprises_about_dogs_and_cats_slideshow/1800x1200_surprises_about_dogs_and_cats_slideshow.jpg',
        'https://static.scientificamerican.com/sciam/cache/file/92E141F8-36E4-4331-BB2EE42AC8674DD3_source.jpg'];

  }

  public logIn() {
      this.router.navigate(['login']);
  }

  public logOut() {
      this.authService.logout();
      this.router.navigate(['']);
      this.alertService.warn('You have been successfully logged out');
  }

  public makeReservation () {
      const data = {
          dateIn: this.dateIn,
          dateOut: this.dateOut,
          numCatPens: this.numCatPens,
          numDogPens: this.numDogPens,
          selectedKennel: this.selectedKennel,
      };
      this.authService.updateBookingData(data);
      if (this.loggedIn) {
          this.router.navigate(['customer/booking/new']);
      } else {
          this.logIn();
      }
  }

  gotoDashBoard() {
      if (this.isAdmin) {
          this.router.navigate(['/admin']);
      } else {
          this.router.navigate(['/customer/tiles']);
      }
  }

}
